import React from 'react';
import { Button } from '../../globalStyles';
import { AiFillThunderbolt } from 'react-icons/ai';
import { GiCrystalBars } from 'react-icons/gi';
import { GiCutDiamond, GiRock } from 'react-icons/gi';
import { GiFloatingCrystal } from 'react-icons/gi';
import { IconContext } from 'react-icons/lib';
import {
  PricingSection,
  PricingWrapper,
  PricingHeading,
  PricingContainer,
  PricingCard,
  PricingCardInfo,
  PricingCardIcon,
  PricingCardPlan,
  PricingCardCost,
  PricingCardLength,
  PricingCardFeatures,
  PricingCardFeature
} from './Pricing.elements';

 const Pricing = () => {
  return (
    <IconContext.Provider value={{ color: '#a9b3c1', size: 64 }}>
      <PricingSection>
        <PricingWrapper>
          <PricingHeading>Our Services</PricingHeading>
          <PricingContainer>
            <PricingCard >
              <PricingCardInfo>
                <PricingCardIcon>
                  <GiRock />
                </PricingCardIcon>
                <PricingCardPlan>DATA Center</PricingCardPlan>
                
                <PricingCardFeatures>
                  <PricingCardFeature>Nareebco- Infrastructure support provides clients and agencies with the most scalable, feasible and reliable infrastructure possible</PricingCardFeature>
                 
                </PricingCardFeatures>
                
              </PricingCardInfo>
            </PricingCard>
            <PricingCard >
              <PricingCardInfo>
                <PricingCardIcon>
                  <GiRock />
                </PricingCardIcon>
                <PricingCardPlan>I.T. Collaboration</PricingCardPlan>
                
                <PricingCardFeatures>
                  <PricingCardFeature>Nareebco- I.T. Collaboration practices specializes in calling, meeting, virtual assistance, messaging, as well as Audio Visual Design and Integration.</PricingCardFeature>
                 
                </PricingCardFeatures>
                
              </PricingCardInfo>
            </PricingCard>

            <PricingCard >
              <PricingCardInfo>
                <PricingCardIcon>
                  <GiRock />
                </PricingCardIcon>
                <PricingCardPlan>Cyber Security</PricingCardPlan>
                
                <PricingCardFeatures>
                  <PricingCardFeature>Nareebco- Cyber Security Solution provides customer with Real-Time Awareness, Enterprise Visibility and Behavior Analytics in order to reduce operational cost.</PricingCardFeature>
                 
                </PricingCardFeatures>
                
              </PricingCardInfo>
            </PricingCard>
          </PricingContainer>
        </PricingWrapper>
      </PricingSection>
    </IconContext.Provider>
  );
}

export default Pricing